var render = function render(){var _vm=this,_c=_vm._self._c;return _c('verification-upload',{on:{"uploaded":_vm.onUploaded}})
}
var staticRenderFns = []

export { render, staticRenderFns }